import { Field, SocialMediaIcon, SocialMediaIconProps } from '@kontentino/ui';
import WorkflowStatusItem from 'app/components/workflowStatus/WorkflowStatusItem';
import HorizontalPostCardImagePreviewWithPostTypeIcon from 'app/modules/posts/components/horizontalPostCard/HorizontalPostCardImagePreviewWithPostTypeIcon';
import { Dayjs } from 'dayjs';
import React, { FC } from 'react';
import PostComposerPlanningContentTimeInput from '../../post/components/composer/postComposerPlanning/PostComposerPlanningContentTimeInput';
import { ListPost } from 'types/PostDetail';
import PageTypeUtils from 'app/utils/pageType';
import SingleDatePicker from 'app/components/datepicker-dropdown/SingleDatePicker';
import dayjs from 'dayjs';
import TimeUtils from 'app/utils/time';

type Props = {
  post: Pick<
    ListPost,
    | 'date'
    | 'time'
    | 'text'
    | 'status'
    | 'subtype'
    | 'type'
    | 'preview_image'
    | 'assigned_users'
    | 'page'
  >;
  onDateChange: (date: Dayjs | null) => void;
  onTimeChange: (time: string) => void;
};
const DuplicatePostPreview: FC<Props> = ({
  post,
  onDateChange,
  onTimeChange,
}) => {
  return (
    <div className="tw-flex tw-gap-3 tw-rounded tw-bg-grayscale-10 tw-p-2">
      <div>
        <HorizontalPostCardImagePreviewWithPostTypeIcon
          image={{
            src: post.preview_image?.src,
            height: 72,
            width: 72,
          }}
          postType={post.type}
          postSubtype={post.subtype}
        />
      </div>
      <div className="tw-w-full">
        <div className="tw-flex tw-w-full tw-items-center tw-justify-between">
          <span className="tw-inline-flex   tw-flex-1 tw-text-sm tw-font-regular tw-text-grayscale-100">
            Duplicate from
            <SocialMediaIcon
              type={
                PageTypeUtils.getName(
                  post.page.type,
                ) as SocialMediaIconProps['type']
              }
              size={14}
              className="tw-ml-2 tw-mr-1"
            />
            <span className="tw-max-w-xs tw-truncate tw-text-grayscale-180 ">
              {post.page.name}
            </span>
          </span>
          <span className="justify-end tw-flex tw-w-40">
            <WorkflowStatusItem
              status={post.status}
              assignedUsers={[]}
              className="tw-justify-end"
            />
          </span>
        </div>

        <div className="tw-mt-2 tw-flex tw-w-full tw-justify-between tw-gap-2">
          <Field.Group className="tw-flex-1">
            <Field.Label>Date</Field.Label>
            <SingleDatePicker
              date={post.date ? dayjs(post.date) : dayjs().startOf('day')}
              onChange={(date) => onDateChange(date)}
              withClearButton
              minDate={dayjs().startOf('day')}
            />
          </Field.Group>
          <Field.Group className="tw-flex-1">
            <Field.Label>Time</Field.Label>
            <div className="tw-z-0">
              <PostComposerPlanningContentTimeInput
                pageId={post.page.id}
                onChange={(time) => {
                  onTimeChange(TimeUtils.normalizeTimeFormat(time));
                }}
                value={post.time}
              />
            </div>
          </Field.Group>
        </div>
        <div className="tw-mt-2 tw-line-clamp-2 tw-text-sm tw-font-regular">
          {post.text}
        </div>
      </div>
    </div>
  );
};

export default DuplicatePostPreview;
